import { withScopeContext } from '@mews/framework';
import { CloseBill as CloseBillPure } from './CloseBill';
import { connectCloseButton } from './connectCloseButton';

export const CloseBill = withScopeContext(connectCloseButton(CloseBillPure));
